import ROUTES from "../routes";
import { RouteConfig } from "vue-router";

export const ProjectsRoutes: Array<RouteConfig> = [
  {
    path: "/projects",
    component: () =>
      import(
        /* webpackChunkName: 'projects' */
        /* webpackPrefetch: true */
        "../../view/wrappers/projects.vue"
      ),
    name: ROUTES.PROJECTS,
  },
];
